import React from 'react'
import styled from '@emotion/styled'
import { keyframes, Typography } from '@mui/material'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { ReactComponent as WarningIcon } from '../../../../assets/warning.svg'
import { ReactComponent as UnionIcon } from '../../../../assets/union.svg'
import { ReactComponent as PendingIcon } from '../../../../assets/pending.svg'
import { ReactComponent as ConversionIcon } from '../../../../assets/conversion.svg'
import DeleteIcon from '@mui/icons-material/Delete'

const fadeOutAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

export const NewText = styled(Typography)(({ theme }) => ({
  color: theme.palette.button.addNew.primary,
  leadingTrim: 'both',
  textEdge: 'cap',
  position: 'absolute',
  top: '30%',
  marginLeft: '27px',
  marginRight: '15px',
  fontFamily: 'Nunito',
  fontSize: '12px',
  animation: `${fadeOutAnimation} ease-out 3s forwards`
}))

export const WarningIconStyle = styled(WarningIcon)(() => ({
  position: 'absolute',
  left: '40%',
  top: '32%'
}))

export const PendingIconStyle = styled(PendingIcon)(() => ({
  position: 'absolute',
  left: '40%',
  top: '32%'
}))

export const UnionIconStyle = styled(UnionIcon)(() => ({
  position: 'absolute',
  left: '40%',
  top: '32%'
}))

export const ConversionIconStyle = styled(ConversionIcon)(() => ({
  position: 'absolute',
  left: '40%',
  top: '32%'
}))

export const SpaceStyle = styled('div')(() => ({
  position: 'absolute',
  left: '40%',
  top: '32%'
}))

export const TooltipStyle = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, color }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 15,
    fontFamily: 'Nunito',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'capitalize',
    color
  }
}))

export const DeleteIconStyle = styled(DeleteIcon)(({ theme }) => ({
  position: 'absolute',
  left: '37%',
  top: '25%',
  height: '20px',
  width: '20px',
  color: `${theme.palette.button.delete.primary}`,
  cursor: 'pointer',
  '& :hover': {
    color: theme.palette.button.delete.hover
  }
}))
